module.exports = __webpack_public_path__ + "img/report_3-1.a48c8fde.png";